import { type FC, useRef, useState } from "react"

import { parseIntNumber, toNumberFormat } from "@forento/core/utilities/number"

type Props = {
	balance: number
	isGranting: boolean
	onGrant(amount: number): void
}
const GrantAiCredits: FC<Props> = ({ balance, isGranting, onGrant }) => {
	const [isHovering, setHovering] = useState(false)
	const [amount, setAmount] = useState("")

	const timeoutRef = useRef<NodeJS.Timeout>(null)

	const parsedAmount = parseIntNumber(amount)
	const canGrant = parsedAmount !== null && parsedAmount > 0 && !isGranting

	const handleMouseEnter = () => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
			timeoutRef.current = null
		}
		setHovering(true)
	}

	const handleMouseLeave = () => {
		timeoutRef.current = setTimeout(() => setHovering(false), 150)
	}

	const handleGrant = () => {
		if (!canGrant) return
		onGrant(parsedAmount)
		setAmount("")
	}

	return (
		<div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<button
				type="button"
				className="cursor-pointer rounded px-2.5 py-1.5 text-white/60 transition-colors hover:bg-white/10 hover:text-white"
			>
				ai: <span className="text-lime-400">{toNumberFormat(balance)}</span>
			</button>

			{isHovering && (
				<div
					className="absolute bottom-full left-0 mb-1 flex items-center gap-1 rounded-lg border border-white/10 bg-black p-1 shadow-2xl"
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					<input
						type="number"
						min={1}
						step={1}
						placeholder="credits"
						value={amount}
						onChange={event => setAmount(event.target.value)}
						className="h-7 w-24 rounded border border-white/10 bg-white/5 px-2 text-xs text-white outline-none placeholder:text-white/30 focus:border-lime-400/50"
					/>
					<button
						type="button"
						onClick={handleGrant}
						disabled={!canGrant}
						className="h-7 cursor-pointer rounded px-2 text-xs text-lime-400 transition-colors hover:bg-white/10 disabled:cursor-not-allowed disabled:text-white/20"
					>
						grant
					</button>
				</div>
			)}
		</div>
	)
}

export default GrantAiCredits
